import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import BbiShell from "../components/BbiShell";
import BbiPricing from "../components/BbiPricing";

export default function BbiPricingPage() {
  useEffect(() => {
    document.title = "Pricing — BrandsByIndia | ₹999 per box/month incl. GST";
    const meta = document.querySelector('meta[name="description"]');
    if (meta) meta.setAttribute("content", "BrandsByIndia pricing: ₹999 per box per month including GST via Razorpay Auto-Pay. More boxes = bigger card, higher placement and more AI articles.");
    window.scrollTo(0, 0);
  }, []);

  return (
    <BbiShell>
      <div className="pt-14 sm:pt-20">
        <div className="max-w-7xl mx-auto px-5 sm:px-8">
          <h1 className="font-mkt-display text-4xl sm:text-5xl font-semibold tracking-tighter text-white">
            Get your brand <span className="mkt-gradient-text-vivid">on the wall.</span>
          </h1>
          <p className="text-sm sm:text-base text-slate-400 mt-3 max-w-2xl">
            Pay online, and your verified page + client login are ready within 24 hours.
            Not sure yet? <Link to="/brands/how-it-works" className="text-indigo-400 hover:text-indigo-300 font-semibold">See how it works →</Link>
          </p>
        </div>
      </div>
      <BbiPricing />
    </BbiShell>
  );
}
